export default "__VITE_ASSET__s0dRM$FJ__"